export enum MessageType {
  AppointmentProposal = 'appointment-proposal',
  MOT = 'mot',
  ProposalDeclined = 'proposal-declined',
  ProposalPlanned = 'proposal-planned'
}
